// extracted by mini-css-extract-plugin
export var numpadContainer = "_p1-1";
export var phoneButton = "_p1-0";